import { applicationGenderSelectOptions } from '@application/utils';
import type { GenderEnum } from '@gql/graphql';
import {
  InfoBox,
  InputField,
  InputLabel,
  InputRadioField,
  InputWrapper,
  Section,
} from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import type { PrefsProps } from './types';

export * from './types';

export const Preferences: FC<PrefsProps> = (props) => {
  const { breedOptions, breederSpokenLanguages } = props;

  const { translate } = useTranslation();
  const { translate: translateRessource } = useTranslation({
    keyPrefix: 'common.inputs',
  });

  return (
    <>
      <Section>
        <InputLabel required size="big">
          {translateRessource('preferredBreeds.label')}
        </InputLabel>
        <InputWrapper>
          <InputRadioField<number> name="breedPreferenceId" options={breedOptions} separated />
        </InputWrapper>
      </Section>

      <Section>
        <InputLabel required size="big">
          {translateRessource('genderPreferences.label')}
        </InputLabel>

        <InputWrapper>
          <InputRadioField<GenderEnum>
            name="genderPreferences"
            separated
            options={
              applicationGenderSelectOptions(translate, {
                isHuman: false,
                showOther: false,
                showText: true,
                showIcons: true,
              }) as any
            }
          />
        </InputWrapper>
      </Section>

      <Section>
        <InputWrapper>
          <InputLabel required size="big">
            {translateRessource('motive.label')}
          </InputLabel>
          <InfoBox>
            {translateRessource('motive.infos').replace('$spokenLanguages', breederSpokenLanguages)}
          </InfoBox>
          <InputField name="motive" textarea />
        </InputWrapper>
      </Section>
    </>
  );
};
